import React from "react";
import { Flame } from "lucide-react";
import SacredChatPage from "./SacredChatPage";
import { PLAYLISTS } from "@/lib/tracks";

const LESSON_TOPICS = {
  fr: [
    "Asha (la Vérité)",
    "Vohu Manah (la Bonne Pensée)",
    "Les 3 piliers (Humata, Hukhta, Hvarshta)",
    "Les Amesha Spentas",
    "Druj (le Mensonge)",
    "Spenta Mainyu vs Angra Mainyu",
    "Frashokereti (la Restauration)",
    "Le feu sacré (Atar)",
    "Zarathoustra (vie et mission)",
    "Les Gāthās",
    "Mithra et le contrat",
    "Daēnā (l'âme-conscience)",
  ],
  en: [
    "Asha (Truth)",
    "Vohu Manah (Good Mind)",
    "The 3 pillars (Humata, Hukhta, Hvarshta)",
    "The Amesha Spentas",
    "Druj (the Lie)",
    "Spenta Mainyu vs Angra Mainyu",
    "Frashokereti (the Renovation)",
    "Sacred fire (Atar)",
    "Zarathustra (life and mission)",
    "The Gāthās",
    "Mithra and the contract",
    "Daēnā (the soul-conscience)",
  ],
};

export default function AhuraMazda() {
  return (
    <SacredChatPage
      persona="ahura"
      personaLabel="Ahura Mazda"
      IconComponent={Flame}
      accent="#f5b800"
      theme={{
        bgRadial: "radial-gradient(ellipse at top, #2b1a08 0%, #150c04 55%, #080500 100%)",
        fg: "#fff2cf",
        msgBg: "linear-gradient(180deg, rgba(28,16,6,0.92), rgba(10,6,2,0.95))",
        msgFg: "#f0d9a4",
      }}
      title={{
        fr: <><span className="italic" style={{ color: "#f5b800" }}>Ahura Mazda</span>, le Seigneur Sage.</>,
        en: <><span className="italic" style={{ color: "#f5b800" }}>Ahura Mazda</span>, the Wise Lord.</>,
      }}
      subtitle={{
        fr: "Dieu suprême de la tradition zoroastrienne, gardien du feu sacré, de la vérité (Asha) et de la bonne pensée (Vohu Manah). Il enseigne les trois piliers : bonnes pensées, bonnes paroles, bonnes actions.",
        en: "Supreme god of the Zoroastrian tradition, keeper of the sacred fire, of truth (Asha) and good thought (Vohu Manah). Teaches the three pillars: good thoughts, good words, good deeds.",
      }}
      greeting={{
        fr: "« Que la Lumière t'enveloppe. Que cherches-tu ? »",
        en: "\"May the Light enfold you. What do you seek?\"",
      }}
      suggestions={{
        fr: [
          "Comment choisir le bien quand tout me pousse à mentir ?",
          "Que dit l'Avesta sur le libre-arbitre ?",
          "Explique-moi Asha et Druj.",
          "Comment nourrir mon feu intérieur aujourd'hui ?",
        ],
        en: [
          "How to choose the good when everything pushes me to lie?",
          "What does the Avesta say about free will?",
          "Explain Asha and Druj.",
          "How to feed my inner fire today?",
        ],
      }}
      playlist={PLAYLISTS.ahura}
      lessonMode={{
        endpoint: "/chat/ahura/lesson",
        title: {
          fr: "Choisis un sujet zoroastrien",
          en: "Pick a Zoroastrian topic",
        },
        topics: LESSON_TOPICS,
      }}
    />
  );
}
